import React, { useState, useEffect, useContext } from "react";
import { Card, Table, Button, Spinner, Container, Form, OverlayTrigger, Popover, Modal, Tooltip } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import authenticatedFetch from "../../utils/fetch"
import NotyfContext from "../../contexts/NotyfContext";
import UsStateSelect from "../../utils/UsStateSelect";
import InputMask from "react-input-mask";
import { useTable, useSortBy, useFilters } from "react-table";
import Select from "react-select";
import { File } from "react-feather";
import rawCarrierTiers from "../../utils/carrierTiers";
import SlimPracticePicker from "../../utils/SlimPracticePicker"
import DocumentManagementModal from "../../utils/DocumentManagementModal";
import AdminEditTypeSelect from "../../utils/AdminEditTypeSelect";
import { caseInsensitiveSort } from "../../utils/reactTableUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
  faFile,
} from "@fortawesome/free-solid-svg-icons";

function equalStrings(a, b)
{
  if (a === null && b === "")
  {
    return true;
  }
  if (a === "" && b === null)
  {
    return true;
  }

  return a === b;
}

function asSortedIds(list) {
  if (!Array.isArray(list)) return [];
  // supports [{id,...}] or primitive ids
  return list
    .map((item) => (typeof item === "object" && item !== null ? item.id : item))
    .filter((v) => v !== undefined && v !== null)
    .map(String)
    .sort();
}

function equalFacilities(a, b) {
  const A = asSortedIds(a);
  const B = asSortedIds(b);
  if (A.length !== B.length) return false;
  for (let i = 0; i < A.length; i++) {
    if (A[i] !== B[i]) return false;
  }
  return true;
}

const IsActiveDisplay = ({isActive, row, practiceId, reload}) => {
  const[localIsActive, setLocalIsActive] = useState(isActive);

  const notyf = useContext(NotyfContext);

  const onIsActiveChanged = (e) => {
    if (!e.target.checked && !window.confirm("Removing " + row.original.name + " from the practice will also delete any provider participation data (carrier level, and lines of business) for " + row.original.name + ", for the TIN + NPI combo.  Are you sure you want to remove this carrier from the practice?"))
    {
      return;
    }
    else if (e.target.checked && !window.confirm("Add " + row.original.name + " to the practice?"))
    {
      return;
    }

    setLocalIsActive(e.target.checked);
    
    authenticatedFetch({
      method: "PUT",
      requestData: {isActive: e.target.checked},
      path:  "carrier/admin/" + row.original.id + "/practice/" + practiceId,
      successHandler: function(result) {
        reload();
        var message = e.target.checked ? "Added!" : "Removed!";
        notyf.open({type: "success", message: message, duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
      },
      errorHandler: function(error) {
        setLocalIsActive(!e.target.checked)
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  return <Form.Check checked={localIsActive} onClick={(e) => {e.stopPropagation()}} onChange={(e) => {onIsActiveChanged(e)}} />;
}

const ActiveHeader = ({data}) => {
  if (data && data.length > 0)
  {
    let countActive = data.filter((item) => item.isActive).length;
    return "(" + countActive + ")";
  }
  
  return (
    "Active"
  )
}

const AlsoUsedByPopover = ({alsoUsedBy}) => {
  if (alsoUsedBy && alsoUsedBy.length > 0) {
    alsoUsedBy = alsoUsedBy.map(function(item, idx) {
      return ( 
          <span key={idx}>
              <li>{item}</li>
          </span>
        )
    });
  }

  return(
    <>
      <div style={{fontWeight: "bold", fontSize: "0.9em", marginTop: "-5px", marginBottom: "-5px"}}>Also Used By</div>
      <span style={{fontStyle: "italic", fontSize: "0.9em"}}><ul>{alsoUsedBy}</ul></span>
    </>
  );
}

const AlsoUsedByDisplay = ({alsoUsedBy}) => {
  var alsoUsedByDisplay = alsoUsedBy.join(', ');
  var showOverlay = false;
  if (alsoUsedByDisplay && alsoUsedByDisplay.length > 75)
  {
    showOverlay = true;
    alsoUsedByDisplay = alsoUsedBy.length + " other practices...";
  }

  if (!showOverlay)
  {
    return <span>{alsoUsedByDisplay}</span>
  }

  return (
    <OverlayTrigger
      triggers="[hover, focus]"
      placement="bottom"
      overlay={<Popover><Popover.Body><AlsoUsedByPopover alsoUsedBy={alsoUsedBy}/></Popover.Body></Popover>}
    >
      <span>{alsoUsedByDisplay}</span>
    </OverlayTrigger>
  )
}

const AddLineOfBusinessConfirmationModal = ({ businessLineName, carrierName, activateForProviders, handleActivateForProvidersChanged, show, onCancel, onConfirm}) => {
    return (
        <Modal show={show} onHide={onCancel} dialogClassName={"modal-850"}>
          <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
            <Modal.Title>
              <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Add business line <b>{businessLineName}</b> to <b>{carrierName}</b> for this practice?</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Table size="sm" striped hover> 
            <tbody>
              <tr>
                <td style={{minWidth: "40px"}}><Form.Check type="checkbox" onChange={(e) => {handleActivateForProvidersChanged(e)}} checked={activateForProviders} /></td>
                <td>Also activate <b>{businessLineName}</b> for any providers who are active with <b>{carrierName}</b> for this practice, for <i>all</i> applicable locations?</td>
              </tr>
            </tbody>
          </Table>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="btn-secondary" onClick={onCancel}>Cancel</Button>
            <Button onClick={onConfirm}>Add</Button>
          </Modal.Footer>
        </Modal>
    );
  }


  const AddLinesOfBusinessConfirmationModal = ({ carrierName, activateForProviders, handleActivateForProvidersChanged, show, onCancel, onConfirm}) => {
    return (
        <Modal show={show} onHide={onCancel} dialogClassName={"modal-850"}>
          <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
            <Modal.Title>
              <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Add all business lines to <b>{carrierName}</b> for this practice?</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Table size="sm" striped hover> 
            <tbody>
              <tr>
                <td style={{minWidth: "40px"}}><Form.Check type="checkbox" onChange={(e) => {handleActivateForProvidersChanged(e)}} checked={activateForProviders} /></td>
                <td>Also activate business lines for any providers who are active with <b>{carrierName}</b> for this practice, for <i>all</i> applicable locations?</td>
              </tr>
            </tbody>
          </Table>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="btn-secondary" onClick={onCancel}>Cancel</Button>
            <Button onClick={onConfirm}>Add All</Button>
          </Modal.Footer>
        </Modal>
    );
  }

const LineOfBusinessRow = ({practiceId, businessLineId, businessLineName, carrierName, isActive, handleIsActiveChanged, refreshCarrierList}) => {
  const[showAddLineOfBusinessConfirmationModal, setShowAddLineOfBusinessConfirmationModal] = useState(false);
  const[activateForProviders, setActivateForProviders] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleAddLineOfBusinessConfirm = () => {
    setShowAddLineOfBusinessConfirmationModal(false);
    updateBusinessLineActive(true);
  }

  const updateBusinessLineActive = (isActive) => {
    handleIsActiveChanged(businessLineId, isActive);

    authenticatedFetch({  
      method: "PUT",
      requestData: {isActive: isActive, activateForProviders: activateForProviders},
      path:  "carrier/admin/businessLine/" + businessLineId + "/practice/" + practiceId,
      successHandler: function(result) {
        refreshCarrierList();
        var message = isActive ? "Added!" : "Removed!";
        notyf.open({type: "success", message: message, duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
      },
      errorHandler: function(error) {
        handleIsActiveChanged(businessLineId, !isActive);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  const handleActiveChanged = (e) => {
    if (!e.target.checked && window.confirm("Removing business line: " + businessLineName + " from " + carrierName + " for this practice will also delete any provider business line participation data for the TIN + NPI + location combos.  Are you sure you want to remove this business line?"))
    {
      updateBusinessLineActive(false);
    }
    else if (e.target.checked)
    {
      setShowAddLineOfBusinessConfirmationModal(true);
    }
  }

  return (
    <>
    <tr>
      <td>
        <Form.Check type="checkbox" onChange={(e) => {handleActiveChanged(e)}} value={businessLineId} checked={isActive} />
      </td>
      <td>{businessLineName}</td>
    </tr>
    <AddLineOfBusinessConfirmationModal businessLineName={businessLineName} carrierName={carrierName} activateForProviders={activateForProviders} handleActivateForProvidersChanged={(e) => {setActivateForProviders(e.target.checked)}} show={showAddLineOfBusinessConfirmationModal} onCancel={() => {setShowAddLineOfBusinessConfirmationModal(false)}} onConfirm={() => {handleAddLineOfBusinessConfirm()}} />
    </>
  );
}

const LinesOfBusinessModal = ({ show, onClose, practiceId, carrierName, businessLines, refreshCarrierList}) => {
  const [showAddLinesOfBusinessConfirmationModal, setShowAddLinesOfBusinessConfirmationModal] = useState(false);
  const [activateForProviders, setActivateForProviders] = useState(false);
  const [localIsActive, setLocalIsActive] = useState({});  // Managing this here to deal with the All All case... kind of ugly
  const [businessLineRows, setBusinessLineRows] = useState([]);
  const [rebuildRows, setRebuildRows] = useState(0);

  const notyf = useContext(NotyfContext);

  useEffect(() => {
    setActivateForProviders(false);
    setLocalIsActive({});
    for (var i=0; i < businessLines.length; i++)
    {
      localIsActive[businessLines[i].id] = businessLines[i].isActive;
    }

    var newRows = businessLines.map(function(item, idx) {
      return (
          <LineOfBusinessRow key={idx} refreshCarrierList={refreshCarrierList} practiceId={practiceId} businessLineId={item.id} businessLineName={item.name} carrierName={carrierName} isActive={localIsActive[item.id]} handleIsActiveChanged={handleRowInactiveChanged} />
        )
    });
    setBusinessLineRows(newRows);
  }, [businessLines, practiceId, rebuildRows])

  const handleClose = () => {
    onClose();
  }

  const handleRowInactiveChanged = (businessLineId, isActive) => {
    for (var i=0; i < businessLines.length; i++)
    {
      if (businessLines[i].id === businessLineId)
      {
        businessLines[i].isActive = isActive;
        break;
      }
    }
  }

  var inactiveBusinessLineIds = businessLines.filter((item) => !item.isActive).map((item) => item.id);
  var areAnyInactive = inactiveBusinessLineIds.length > 0;

  const handleActivateAll = () => {
    setShowAddLinesOfBusinessConfirmationModal(true);
  }

  const handleActivateAllConfirm = () => {
    setShowAddLinesOfBusinessConfirmationModal(false);

    var inactiveCopy = inactiveBusinessLineIds.slice();

    for (var i=0; i < businessLines.length; i++)
    {
      businessLines[i].isActive = true;
      setRebuildRows(Date.now()); // Hack; our state mgmt is all messed up
    }

    authenticatedFetch({  
      method: "POST",
      requestData: {activateForProviders: activateForProviders, businessLineIds: inactiveCopy},
      path:  "carrier/admin/all/businessLine/practice/" + practiceId,
      successHandler: function(result) {
        refreshCarrierList();
        var message = "Added " + inactiveCopy.length + " business line" + (inactiveCopy.length > 1 ? "s" : "") + "!";
        notyf.open({type: "success", message: message, duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
      },
      errorHandler: function(error) {
        for (var i=0; i < businessLines.length; i++)
        {
          if (inactiveCopy.indexOf(businessLines[i].id) >= 0)
          {
            businessLines[i].isActive = false;
          }
        }
        setRebuildRows(Date.now());
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
            <Modal.Title>
            Lines of Business for {carrierName}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table size="sm" striped hover> 
            <thead>
              <tr>
                <th>Active</th>
                <th>Line of Business</th>
              </tr>
            </thead>
            <tbody>
              {businessLineRows}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
          {areAnyInactive && <Button className="me-auto" onClick={handleActivateAll} size="sm">Add All</Button>}
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <AddLinesOfBusinessConfirmationModal carrierName={carrierName} activateForProviders={activateForProviders} handleActivateForProvidersChanged={(e) => {setActivateForProviders(e.target.checked)}} show={showAddLinesOfBusinessConfirmationModal} onCancel={() => {setShowAddLinesOfBusinessConfirmationModal(false)}} onConfirm={() => {handleActivateAllConfirm()}} />
    </>
  );
}

const BusinessLinesDisplay = ({businessLines, practiceId, row, refreshCarrierList}) => {
  const [showLinesOfBusiness, setShowLinesOfBusiness] = useState(false);
  const handleCloseLinesOfBusiness = () => setShowLinesOfBusiness(false);

  let denominator = businessLines.length;
  let numerator = businessLines.filter((item) => item.isActive).length;
  
  const handleShowLinesOfBusiness = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowLinesOfBusiness(true);
  }

  if (!row.original.isActive)
  {
    return <small>(n/a)</small>
  }

  if (denominator === 0)
  {
    return <>0 of 0</>
  }

  return (
    <>
      <a href="#" onClick={(e) => handleShowLinesOfBusiness(e)}>{numerator} of {denominator}</a>
      <LinesOfBusinessModal refreshCarrierList={refreshCarrierList} businessLines={businessLines} practiceId={practiceId} carrierName={row.original.name} show={showLinesOfBusiness} onClose={handleCloseLinesOfBusiness} />
    </>
  )
}


function SearchColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {

  return (
    <Form.Control 
      size="sm"
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      onClick = {(e) => {e.stopPropagation()}}
      placeholder={`Search...`}
      className="mt-2"
      style={{width: "150px", display: "inline", marginLeft:"8px"}}
    />
  );
}

function containsAllWords(words, name)
{
  for (var i=0; i < words.length; i++)
  {
    if(!name || name.toLowerCase().indexOf(words[i].trim().toLowerCase()) < 0)
    {
      return false;
    }
  }

  return true;
}

function customNameFilter(rows, columnIds, filterValue) {
  return rows.filter((row) => {
      if (!filterValue)
      {
        return true;
      }

      let words = filterValue.trim().split(" ");
      return containsAllWords(words, row.original.name);
  });
}

function customOthersUsedByFilter(rows, columnIds, filterValue) {
  return rows.filter((row) => {
      if (!filterValue)
      {
        return true;
      }

      if (!row.original.othersUsedBy || row.original.othersUsedBy.length === 0)
      {
        return false;
      }

      // Look across all practice names
      let words = filterValue.trim().split(" ");
      for (var i=0; i < words.length; i++)
      {
        var wordFound = false;
        for (var j=0; j < row.original.othersUsedBy.length; j++)
        {
          if(row.original.othersUsedBy[j] && row.original.othersUsedBy[j].toLowerCase().indexOf(words[i].trim().toLowerCase()) >= 0)
          {
            wordFound = true;
            break;
          }
        }

        if (!wordFound)
        {
          return false;
        }
      }

      return true;
  });
}

const FacilitySelect = ({ practiceId, handleFacilityChanged, selectedFacilities}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
      authenticatedFetch({
          path: "facility/admin/active/practice/" + practiceId,
              successHandler: function(result) {
              setIsLoaded(true);
              setData(result);
          },
          errorHandler: function(error) {
              setIsLoaded(true);
              setError(error);
          }
      });
  }, [practiceId])

  const options = data.map((facility) => {
      return {value: facility.id, label: facility.name};
  });

  if (!isLoaded)
  {
    return (<Form.Select style={{height: "38px", width: "50%", display: "inline-block", marginLeft: "5%"}} disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
  }
  else if (error || !data)
  {
    return (<Form.Select style={{height: "38px", width: "50%", display: "inline-block", marginLeft: "5%"}} disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
  }
  else
  {
      return (
          <div style={{ width: "50%", display: "inline-block", marginLeft: "5%"}}>
              <Select
              options={options}
              onChange={(selectedFacilities) => {
                handleFacilityChanged(selectedFacilities);
              }}
              value={selectedFacilities}
              placeholder="Select facilities..."
              isMulti
              theme={(theme) => ({
                ...theme,
                colors: {
                ...theme.colors,
                  primary50: '#DEF2F1',
                  primary25: '#DEF2F1',
                  primary: '#3AAFA9',
                },
              })}
              />
          </div>
      )
  }
}


const CarrierModal = ({show, onHide, onSave, id, name, portalUrl, state, phone, fax, email, requiresManualLicenseUpdate, initialEnrollmentEmails, initialEnrollmentInstructions, reEnrollmentInstructions, otherInstructions, terminationInstructions, practiceInitialEnrollmentEmails, practiceInitialEnrollmentInstructions, practiceReEnrollmentInstructions, practiceOtherInstructions, practiceTerminationInstructions, practiceCarrierTier, practiceFacilityDependencies, othersUsedBy, practiceId, practiceName}) => {
  const[isSaving, setIsSaving] = useState(false);

  const notyf = useContext(NotyfContext);

  if (!id || id === null)
  {
    id = 0;
  }  
  if (!name || name === null)
  {
    name = "";
  }
  if (!portalUrl || portalUrl === null)
  {
    portalUrl = "";
  }
  if (!state || state === null)
  {
    state = "";
  }
  if (!phone || phone === null)
  {
    phone = "";
  }
  if (!fax || fax === null)
  {
    fax = "";
  }
  if (!email || email === null)
  {
    email = "";
  }
  if (requiresManualLicenseUpdate === null || requiresManualLicenseUpdate === undefined)
  {
    requiresManualLicenseUpdate = false;
  }
  if (!initialEnrollmentEmails || initialEnrollmentEmails === null)
  {
    initialEnrollmentEmails = "";
  }
  if (!initialEnrollmentInstructions || initialEnrollmentInstructions === null)
  {
    initialEnrollmentInstructions = "";
  }
  if (!reEnrollmentInstructions || reEnrollmentInstructions === null)
  {
    reEnrollmentInstructions = "";
  }
  if (!terminationInstructions || terminationInstructions === null)
  {
    terminationInstructions = "";
  }
  if (!otherInstructions || otherInstructions === null)
  {
    otherInstructions = "";
  }
  if (!practiceInitialEnrollmentEmails || practiceInitialEnrollmentEmails === null)
  {
    practiceInitialEnrollmentEmails = "";
  }
  if (!practiceInitialEnrollmentInstructions || practiceInitialEnrollmentInstructions === null)
  {
    practiceInitialEnrollmentInstructions = "";
  }
  if (!practiceReEnrollmentInstructions || practiceReEnrollmentInstructions === null)
  {
    practiceReEnrollmentInstructions = "";
  }
  if (!practiceTerminationInstructions || practiceTerminationInstructions === null)
  {
    practiceTerminationInstructions = "";
  }
  if (!practiceOtherInstructions || practiceOtherInstructions === null)
  {
    practiceOtherInstructions = "";
  }
  if (!practiceCarrierTier || practiceCarrierTier === null)
  {
    practiceCarrierTier = "";
  }
  if (!practiceFacilityDependencies || practiceFacilityDependencies === null)
  {
    practiceFacilityDependencies = [];
  }


  const [localName, setLocalName] = useState(name);
  const [localPortalUrl, setLocalPortalUrl] = useState(portalUrl);
  const [localState, setLocalState] = useState(state);
  const [localPhone, setLocalPhone] = useState(phone);
  const [localFax, setLocalFax] = useState(fax);
  const [localEmail, setLocalEmail] = useState(email);
  const [localRequiresManualLicenseUpdate, setLocalRequiresManualLicenseUpdate] = useState(requiresManualLicenseUpdate);
  const [localInitialEnrollmentEmails, setLocalInitialEnrollmentEmails] = useState(id > 0 ? practiceInitialEnrollmentEmails : initialEnrollmentEmails);
  const [localInitialEnrollmentInstructions, setLocalInitialEnrollmentInstructions] = useState(id > 0 ? practiceInitialEnrollmentInstructions : initialEnrollmentInstructions);
  const [localReEnrollmentInstructions, setLocalReEnrollmentInstructions] = useState(id > 0 ? practiceReEnrollmentInstructions : reEnrollmentInstructions);
  const [localTerminationInstructions, setLocalTerminationInstructions] = useState(id > 0 ? practiceTerminationInstructions : terminationInstructions);
  const [localOtherInstructions, setLocalOtherInstructions] = useState(id > 0 ? practiceOtherInstructions : otherInstructions);
  const [localCarrierTier, setLocalCarrierTier] = useState(practiceCarrierTier);
  const [localPracticeFacilityDependencies, setLocalPracticeFacilityDependencies] = useState(practiceFacilityDependencies);
  const [localAddToPractice, setLocalAddToPractice] = useState(true);
  const [selectedEditType, setSelectedEditType] = useState(id > 0 ? "PRACTICE" : "GLOBAL");

  const reset = () => {
    setLocalName(!name || name === null ? "" : name);
    setLocalPortalUrl(!portalUrl || portalUrl === null ? "" : portalUrl);
    setLocalState(!state || state === null ? "" : state);
    setLocalPhone(!phone || phone === null ? "" : phone);
    setLocalFax(!fax || fax === null ? "" : fax);
    setLocalEmail(!email || email === null ? "" : email);
    setLocalRequiresManualLicenseUpdate(requiresManualLicenseUpdate === null || requiresManualLicenseUpdate === undefined ? false : requiresManualLicenseUpdate);

    if (id > 0)
    {
      setLocalInitialEnrollmentEmails(!practiceInitialEnrollmentEmails || practiceInitialEnrollmentEmails === null ? "" : practiceInitialEnrollmentEmails);
      setLocalInitialEnrollmentInstructions(!practiceInitialEnrollmentInstructions || practiceInitialEnrollmentInstructions === null ? "" : practiceInitialEnrollmentInstructions);
      setLocalReEnrollmentInstructions(!practiceReEnrollmentInstructions || practiceReEnrollmentInstructions === null ? "" : practiceReEnrollmentInstructions);
      setLocalTerminationInstructions(!practiceTerminationInstructions || practiceTerminationInstructions === null ? "" : practiceTerminationInstructions);
      setLocalOtherInstructions(!practiceOtherInstructions || practiceOtherInstructions === null ? "" : practiceOtherInstructions);
    }
    else
    {
      setLocalInitialEnrollmentEmails(!initialEnrollmentEmails || initialEnrollmentEmails === null ? "" : initialEnrollmentEmails);
      setLocalInitialEnrollmentInstructions(!initialEnrollmentInstructions || initialEnrollmentInstructions === null ? "" : initialEnrollmentInstructions);
      setLocalReEnrollmentInstructions(!reEnrollmentInstructions || reEnrollmentInstructions === null ? "" : reEnrollmentInstructions);
      setLocalTerminationInstructions(!terminationInstructions || terminationInstructions === null ? "" : terminationInstructions);
      setLocalOtherInstructions(!otherInstructions || otherInstructions === null ? "" : otherInstructions);
    }

    setLocalCarrierTier(!practiceCarrierTier || practiceCarrierTier === null ? "" : practiceCarrierTier);
    setLocalPracticeFacilityDependencies(!practiceFacilityDependencies || practiceFacilityDependencies === null ? [] : practiceFacilityDependencies);

    setLocalAddToPractice(true);
    setSelectedEditType(id > 0 ? "PRACTICE" : "GLOBAL");
  }

  const handleSave = () => {
    if (id > 0 && othersUsedBy && othersUsedBy.length > 0 && selectedEditType === "GLOBAL" && !window.confirm(name + " is used by " + othersUsedBy.length + " other practice" + (othersUsedBy.length > 1 ? "s" : "") + ".  Are you sure you want to update this carrier?"))
    {
      return;
    }

    setIsSaving(true);

    let requestData = {
        id: id,
        initialEnrollmentEmails: localInitialEnrollmentEmails,
        initialEnrollmentInstructions: localInitialEnrollmentInstructions,
        reEnrollmentInstructions: localReEnrollmentInstructions,
        terminationInstructions: localTerminationInstructions,
        otherInstructions: localOtherInstructions,
        carrierTier: localCarrierTier,
        practiceId: practiceId,
        editType: selectedEditType
    }

    if (selectedEditType === "GLOBAL")
    {
      requestData["name"] = localName;
      requestData["portalUrl"] = localPortalUrl;
      requestData["state"] = localState;
      requestData["phone"] = localPhone;
      requestData["fax"] = localFax;
      requestData["email"] = localEmail;
      requestData["requiresManualLicenseUpdate"] = localRequiresManualLicenseUpdate;
      requestData["addToPractice"] = localAddToPractice;
    }

    if (selectedEditType === "PRACTICE")
    {
      requestData["carrierTier"] = localCarrierTier;
      requestData["facilityDependencies"] = localPracticeFacilityDependencies.map((item) => item.id);
    }

    authenticatedFetch({
      method: "POST",
      requestData: requestData,
      path:  "carrier/admin",
      successHandler: function(result) {
        setIsSaving(false);
        onSave();
        if (!id || id === null || id <= 0)
        {
          reset();
        }
        var message = id > 0 ? "Carrier Updated!" : "Carrier Added!";
        notyf.open({type: "success", message: message, duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
      },
      errorHandler: function(error) {
        setIsSaving(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  const handleCancel = () => {
    onHide();
    reset();
  }

  const handleNameChanged = (name) => {
    setLocalName(name);
  }

  const handlePortalUrlChanged = (portalUrl) => {
    setLocalPortalUrl(portalUrl);
  }

  const handleStateChanged = (name, state) => {
    setLocalState(state);
  }

  const handlePhoneChanged = (phone) => {
    setLocalPhone(phone.replace(/_/g, ''));
  }

  const handleFaxChanged = (fax) => {
    setLocalFax(fax.replace(/_/g, ''));
  }

  const handleEmailChanged = (email) => {
    setLocalEmail(email);
  }

  const handleRequiresManualLicenseUpdateChanged = (val) => {
    setLocalRequiresManualLicenseUpdate(val);
  }

  const handleInitialEnrollmentEmailsChanged = (emails) => {
    setLocalInitialEnrollmentEmails(emails);
  }

  const handleInitialEnrollmentInstructionsChanged = (instructions) => {
    setLocalInitialEnrollmentInstructions(instructions);
  }

  const handleReEnrollmentInstructionsChanged = (instructions) => {
    setLocalReEnrollmentInstructions(instructions);
  }

  const handleTerminationInstructionsChanged = (instructions) => {
    setLocalTerminationInstructions(instructions);
  }

  const handleOtherInstructionsChanged = (instructions) => {
    setLocalOtherInstructions(instructions);
  }

  const handleCarrierTierChanged = (tier) => {
    setLocalCarrierTier(tier);
    setLocalPracticeFacilityDependencies([]);
  }

  const handlePracticeFacilityDependenciesChanged = (facilities) => {
    setLocalPracticeFacilityDependencies(facilities ? facilities.map((item) => ({id: item.value, name: item.label})) : []);
  }

  const handleAddToPracticeChanged = (val) => {
    setLocalAddToPractice(val);
  }

  const handleEditTypeChanged = (editType) => {
    if (allowSave() && !window.confirm("Changing the edit type will discard any unsaved changes.  Are you sure you want to change the edit type?"))
    {
      return;
    }

    reset();
    setSelectedEditType(editType);

    if (editType === "PRACTICE")
    {
      setLocalInitialEnrollmentEmails(practiceInitialEnrollmentEmails);
      setLocalInitialEnrollmentInstructions(practiceInitialEnrollmentInstructions);
      setLocalReEnrollmentInstructions(practiceReEnrollmentInstructions);
      setLocalTerminationInstructions(practiceTerminationInstructions);
      setLocalOtherInstructions(practiceOtherInstructions);
    }
    else
    {
      setLocalInitialEnrollmentEmails(initialEnrollmentEmails);
      setLocalInitialEnrollmentInstructions(initialEnrollmentInstructions);
      setLocalReEnrollmentInstructions(reEnrollmentInstructions);
      setLocalTerminationInstructions(terminationInstructions);
      setLocalOtherInstructions(otherInstructions);
    }
  }
    

  const isPhoneNumberValid = (value) => {
    if (value === "" || value === "() -")
    {
      return true;
    }
    
    var res = value.match(/^\((\d{3})\) (\d{3})-(\d{4})$/);
    return res != null;
  }

  const isNameValid = () => {
    return localName && localName.length > 1;
  }

  const isPortalUrlValid = () => {
    return localPortalUrl === "" || (localPortalUrl.indexOf("http://") === 0 || localPortalUrl.indexOf("https://") === 0);
  }

  const isPhoneValid = () => {
    return isPhoneNumberValid(localPhone);
  }

  const isFaxValid = () => {
    return isPhoneNumberValid(localFax);
  }

  const isEmailAddressValid = (emailAddress) => {
    return emailAddress === "" || (emailAddress.indexOf("@") > -1 && emailAddress.indexOf(".") > -1 && emailAddress.length > 5);
  }

  const isEmailValid = () => {
    return isEmailAddressValid(localEmail);
  }

  const areInitialEnrollmentEmailsValid = () => {
    if (localInitialEnrollmentEmails === "")
    {
      return true;
    }    

    const emailList = localInitialEnrollmentEmails.split(",").map(function(item) {
      return item.trim();
    });

    for (var i=0; i < emailList.length; i++)
    {
      if (emailList[i] === "")
      {
        return false;
      }

      if (!isEmailAddressValid(emailList[i]))
      {
        return false;
      }
    }
    

    return true;
  }

  const areCarrierFacilityDependenciesValid = () => {
    if (localCarrierTier !== "TIER_4")
    {
      return true;
    }

    return localPracticeFacilityDependencies && localPracticeFacilityDependencies.length > 0;
  }

  const allowSave = () => {
    if (isSaving)
    {
      return false;
    }

    if (selectedEditType === "PRACTICE")
    {
      return (
      areInitialEnrollmentEmailsValid() && 
      areCarrierFacilityDependenciesValid() &&
      (!equalStrings(practiceInitialEnrollmentEmails, localInitialEnrollmentEmails) || 
        !equalStrings(practiceInitialEnrollmentInstructions, localInitialEnrollmentInstructions) || 
        !equalStrings(practiceReEnrollmentInstructions, localReEnrollmentInstructions) ||
        !equalStrings(practiceTerminationInstructions, localTerminationInstructions) ||
        !equalStrings(practiceOtherInstructions, localOtherInstructions) ||
        !equalStrings(practiceCarrierTier, localCarrierTier) ||
        !equalFacilities(practiceFacilityDependencies, localPracticeFacilityDependencies)
      ));
    }

    return (isNameValid() && 
      isPortalUrlValid() && 
      isPhoneValid() && 
      isFaxValid() && 
      isEmailValid() && 
      areInitialEnrollmentEmailsValid() && 
      ( !equalStrings(name, localName) || 
        !equalStrings(portalUrl, localPortalUrl) || 
        !equalStrings(state, localState) || 
        !equalStrings(phone, localPhone) || 
        !equalStrings(fax, localFax) || 
        !equalStrings(email, localEmail) || 
        requiresManualLicenseUpdate !== localRequiresManualLicenseUpdate ||
        !equalStrings(initialEnrollmentEmails, localInitialEnrollmentEmails) || 
        !equalStrings(initialEnrollmentInstructions, localInitialEnrollmentInstructions) || 
        !equalStrings(reEnrollmentInstructions, localReEnrollmentInstructions) ||
        !equalStrings(terminationInstructions, localTerminationInstructions) ||
        !equalStrings(otherInstructions, localOtherInstructions)))
  }

  var title = id > 0 ? "Edit Carrier: (" + id + ") " + localName : "Add Carrier: " + localName;
  if (selectedEditType === "PRACTICE")
  {
    title += " for " + practiceName;
  }

  let carrierTierList = rawCarrierTiers.map((tier, i) => {
    return (
      <option key={i} value={tier.value}>{tier.label}</option>
    )
  });

  var selectedPracticeFacilityDependenciesTransformed = [];
  if(localPracticeFacilityDependencies)
  {
    for(let i = 0; i < localPracticeFacilityDependencies.length; i++)
    {
      selectedPracticeFacilityDependenciesTransformed.push({value: localPracticeFacilityDependencies[i].id, label: localPracticeFacilityDependencies[i].name});
    }
  }

  return (
    <Modal show={show} onHide={handleCancel} centered dialogClassName={"modal-850"}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
            <Modal.Title>
            {title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table> 
                <tbody>
                <tr>
                  <td>Editing for:</td>
                  {id > 0 ?
                  <td><AdminEditTypeSelect disabled={isSaving} selectedEditType={selectedEditType} handleEditTypeChanged={handleEditTypeChanged} practiceName={practiceName} /></td>
                  :
                  <td>Global</td>
                  }
                </tr>
                { selectedEditType === "GLOBAL" &&
                <>
                <tr>
                    <td style={{width: "200px"}}>Name:</td>
                    <td><Form.Control style={{height: "38px", width: "95%"}} onChange={(e) => {handleNameChanged(e.target.value, e)}} value={localName} /></td>
                </tr>
                <tr>
                    <td>Portal URL:</td>
                    <td><Form.Control style={{height: "38px", width: "95%"}} onChange={(e) => {handlePortalUrlChanged(e.target.value, e)}} value={localPortalUrl} /></td>
                </tr>
                <tr>
                    <td>State:</td>
                    <td><UsStateSelect placeholder="State" originalValue={localState} name="state" onValueChanged={handleStateChanged}/></td>
                </tr>
                <tr>
                    <td>Phone:</td>
                    <td>
                      <InputMask
                        style={{height: "38px", width: "95%"}}
                        mask='(999) 999-9999'
                        value={localPhone} 
                        onChange={(e) => {handlePhoneChanged(e.target.value)}} >
                        {(inputProps) => <Form.Control {...inputProps} type="text" />}
                      </InputMask>
                    </td>
                </tr>
                <tr>
                    <td>Fax:</td>
                    <td>
                      <InputMask
                        style={{height: "38px", width: "95%"}}
                        mask='(999) 999-9999'
                        value={localFax} 
                        onChange={(e) => {handleFaxChanged(e.target.value)}} >
                        {(inputProps) => <Form.Control {...inputProps} type="text" />}
                      </InputMask>
                    </td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td><Form.Control style={{height: "38px", width: "95%"}} onChange={(e) => {handleEmailChanged(e.target.value, e)}} value={localEmail} /></td>
                </tr>
                <tr>
                  <td>Requires License Update:</td>
                  <td><Form.Check checked={localRequiresManualLicenseUpdate} onChange={(e) => {handleRequiresManualLicenseUpdateChanged(e.target.checked)}} /></td>
                </tr>
                </>
                }

                { selectedEditType === "PRACTICE" &&
                <>
                <tr>
                    <td style={{width: "200px"}}>Carrier Tier:</td>
                    <td>
                      <Form.Select value={localCarrierTier} onChange={(e) => {handleCarrierTierChanged(e.target.value, e)}} style={{display: "inline-block", height: "38px", width: "40%"}} >
                        {carrierTierList}
                      </Form.Select>
                      {localCarrierTier === 'TIER_4' && <FacilitySelect practiceId={practiceId} selectedFacilities={selectedPracticeFacilityDependenciesTransformed} handleFacilityChanged={handlePracticeFacilityDependenciesChanged}/> }
                    </td>
                </tr>
                </>
                }
                <tr>
                  <td style={{width: "200px"}}>Initial Enrollment Emails (comma-separated; populate this field to enable the bot!):</td>
                  <td><Form.Control style={{height: "38px", width: "95%"}} onChange={(e) => {handleInitialEnrollmentEmailsChanged(e.target.value, e)}} value={localInitialEnrollmentEmails} /></td>
                </tr>
                <tr>
                  <td>Initial Enrollment Instructions:</td>
                  <td><Form.Control as={"textarea"} style={{width: "95%", height: "100px"}} onChange={(e) => {handleInitialEnrollmentInstructionsChanged(e.target.value, e)}} value={localInitialEnrollmentInstructions} /></td>
                </tr>
                <tr>
                  <td>Re-enrollment Instructions:</td>
                  <td><Form.Control as={"textarea"} style={{width: "95%", height: "100px"}} onChange={(e) => {handleReEnrollmentInstructionsChanged(e.target.value, e)}} value={localReEnrollmentInstructions} /></td>
                </tr>
                <tr>
                  <td>Termination Instructions:</td>
                  <td><Form.Control as={"textarea"} style={{width: "95%", height: "100px"}} onChange={(e) => {handleTerminationInstructionsChanged(e.target.value, e)}} value={localTerminationInstructions} /></td>
                </tr>
                <tr>
                  <td>Other Instructions:</td>
                  <td><Form.Control as={"textarea"} placeholder="Address updates, etc." style={{width: "95%", height: "100px"}} onChange={(e) => {handleOtherInstructionsChanged(e.target.value, e)}} value={localOtherInstructions} /></td>
                </tr>
                { id == 0 &&
                <tr>
                  <td>Add to {practiceName}:</td>
                  <td><Form.Check checked={localAddToPractice} onChange={(e) => {handleAddToPracticeChanged(e.target.checked)}} /></td>
                </tr>
                }
                </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
          { isSaving ? 
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '40px', marginTop: '11px', marginBottom: '11px'}}/>
            :
            <>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button onClick={handleSave} disabled={!allowSave()}>{id > 0 ? "Update" : "Create"}</Button>
            </>
          }
        </Modal.Footer>
    </Modal>
  );
}

const CarrierRow = ({practiceId, practiceName, row, refreshCarrierList}) => {
  const [show, setShow] = useState(false);

  const handleShow = (key) => {
    if (key === "isActive" || key==="businessLines" || key==="documents")
    {
      return;
    }

    setShow(true);
  }

  const handleCancel = () => {
    setShow(false);
  }

  const handleSave = () => {
    setShow(false);
    refreshCarrierList();
  }

  return (
    <tr {...row.getRowProps()}>
      {row.cells.map((cell) => {
        if (row.original.isActive)
        {
          return (
            <td onClick={(e) => handleShow(cell.column.key)} {...cell.getCellProps()} style={{cursor: (cell.column.key==="isActive" || cell.column.key==="businessLines" || cell.column.key==="documents") ? "" : "pointer", whiteSpace: cell.column.key==="phone" || cell.column.key==="fax" ? "nowrap" : ""}}>
              {cell.render("Cell")}
            </td>
          );
        }
        return (
          <td {...cell.getCellProps()} style={{whiteSpace: cell.column.key==="phone" || cell.column.key==="fax" ? "nowrap" : ""}}>
            {cell.render("Cell")}
          </td>
        );
      })}
      <CarrierModal key={row.original.id} show={show} onHide={handleCancel} onSave={handleSave} id={row.original.id} name={row.original.name} 
      portalUrl={row.original.portalUrl} state={row.original.state} phone={row.original.phone} fax={row.original.fax} email={row.original.email} 
      requiresManualLicenseUpdate={row.original.requiresManualLicenseUpdate}
      initialEnrollmentEmails={row.original.initialEnrollmentEmails} initialEnrollmentInstructions={row.original.initialEnrollmentInstructions} 
      reEnrollmentInstructions={row.original.reEnrollmentInstructions} othersUsedBy={row.original.othersUsedBy} 
      terminationInstructions={row.original.terminationInstructions}
      otherInstructions={row.original.otherInstructions}
      practiceInitialEnrollmentEmails={row.original.practiceInitialEnrollmentEmails}
      practiceInitialEnrollmentInstructions={row.original.practiceInitialEnrollmentInstructions}
      practiceReEnrollmentInstructions={row.original.practiceReEnrollmentInstructions}
      practiceTerminationInstructions={row.original.practiceTerminationInstructions}
      practiceOtherInstructions={row.original.practiceOtherInstructions}
      practiceCarrierTier={row.original.practiceCarrierTier} practiceFacilityDependencies={row.original.practiceFacilityDependencies}
      practiceId={practiceId} practiceName={practiceName} />
    </tr>           
  )
}



const CarrierList = ({practiceId, practiceName}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  }

  const handleCancel = () => {
    setShow(false);
  }

  const handleSave = () => {
    setShow(false);
    refreshCarrierList();
  }

  useEffect(() => {
    refreshCarrierList();
  }, [practiceId, practiceName])

  const refreshCarrierList = () => {
    authenticatedFetch({
      path: "carrier/admin/practice/" + practiceId,
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }

  const columns = React.useMemo(
    () => [
      {
        Header: (param1) => {
          return (
            <ActiveHeader data={param1.data}/>
          );
        },
        accessor: "isActive",
        key: "isActive",
        Cell: ({ value, row }) => (
          <IsActiveDisplay key={row.original.id} isActive={value} row={row} practiceId={practiceId} reload={refreshCarrierList}/>
        ),
        sortType: (rowA, rowB, columnId, desc) => {
          if (rowA.values[columnId] === rowB.values[columnId]) {
            return rowA.original.name.localeCompare(rowB.original.name);
          }

          if (rowA.values[columnId] && !rowB.values[columnId]) {
            return -1;
          }

          return 1;
        },
      },
      {
        Header: "ID",
        accessor: "id",
        key: "id",
      },
      {
        Header: "Name",
        accessor: "name",
        key: "name",
        Filter: SearchColumnFilter,
        filter: customNameFilter,
      },
      {
        key: "documents",
        id: "documents",
        Header: () => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Documents</Tooltip>}
          >
            <span>
              <File size={16} />
            </span>
          </OverlayTrigger>
        ),
        Cell: ({ value, row }) => 
        {
          const [show, setShow] = useState(false);

          const handleShow = (e) => {
            e.stopPropagation();
            setShow(true);
          }

          const handleCancel = () => {
            setShow(false);
          }


          if (row.original.isActive)
          {
            return (
              <>
                <FontAwesomeIcon onClick={(e) => handleShow(e)} icon={faFile} style={{width: "16px", height: "16px", cursor: "pointer", marginLeft: "1px", marginRight: "1px"}}/>
                <DocumentManagementModal show={show} onClose={handleCancel} entityId={row.original.id} practiceName={practiceName} practiceId={practiceId} entityName={row.original.name} entityType="carrier" alsoUsedBy={value} />
              </>
            );
          }
          return <>&nbsp;&nbsp;</>;
        },
      },
      {
        Header: "LOBs",
        accessor: "businessLines",
        key: "businessLines",
        Cell: ({ value, row }) => (
          <BusinessLinesDisplay refreshCarrierList={refreshCarrierList} businessLines={value} practiceId={practiceId} row={row} />
        ),
      },
      // {
      //   Header: "Portal URL",
      //   accessor: "portalUrl",
      //   key: "portalUrl",
      //   Cell: ({ value, row }) => {
      //     var valueDisplay = value;
      //     if (valueDisplay && valueDisplay.length > 35)
      //     {
      //       valueDisplay = valueDisplay.substring(0, 32) + "...";
      //     }
      //     return (
      //       <small>{valueDisplay}</small>
      //     )
      //   },
      // },
      {
        Header: "State",
        accessor: "state",
        key: "state",
      },
      {
        Header: "Phone",
        accessor: "phone",
        key: "phone",
      },
      {
        Header: "Fax",
        accessor: "fax",
        key: "fax",
      },
      {
        Header: "Email",
        accessor: "email",
        key: "email",
      },
      // {
      //   Header: "Initial Enrollment Email",
      //   accessor: "initialEnrollmentEmail",
      //   key: "initialEnrollmentEmail",
      // },
      {
        Header: "Used By",
        accessor: "othersUsedBy",
        key: "othersUsedBy",
        Cell: ({ value, row }) => (
          <AlsoUsedByDisplay alsoUsedBy={value} />
        ),
        Filter: SearchColumnFilter,
        filter: customOthersUsedByFilter,
      }
    ],
  []
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
  useTable(
    {
      columns,
      data,
      autoResetSortBy: false,
      autoResetFilters: false,
      initialState: {
        sortBy: [
          {
              id: 'isActive',
              desc: false
          }
        ]
      },
      sortTypes: {
        alphanumeric: (row1, row2, columnName) => caseInsensitiveSort({row1, row2, columnName})
      }
    },
    useFilters,
    useSortBy,
  );

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <h4 className="float-start card-title">All Carriers</h4>
        <Button className="float-end" variant="primary" size="sm" onClick={(e) => {handleShow()}}>+ Add New Carrier</Button>
        <br /><br />
      </Card.Header>
      <Table className="table-sm" striped bordered {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  const { key, style, ...restHeaderProps } = (column.id === "othersUsedBy" || column.id === "businessLines") ? column.getHeaderProps() : column.getHeaderProps(column.getSortByToggleProps());
                  return (
                    <th {...restHeaderProps} key={key} style={{...style, whiteSpace: (column.key !== "name" && column.key !== "othersUsedBy" && column.key !== "businessLines") ? "nowrap" : ""}}>
                      {column.render("Header")}
                      {(column.id !== "othersUsedBy" && column.id !== "businessLines" && column.id !== "documents") ? (
                        <>
                        {column.isSorted ? (
                            column.isSortedDesc ? (
                              <FontAwesomeIcon icon={faSortDown} className="ms-2" />
                            ) : (
                              <FontAwesomeIcon icon={faSortUp} className="ms-2" />
                            )
                          ) : (
                            <FontAwesomeIcon icon={faSort} className="ms-2" />
                        )}
                        </>
                      ) : <></>
                      }
                      {
                        (column.key === "name" || column.key === "othersUsedBy") ? <>{column.render("Filter")}</>
                        :
                        <></>
                      }
                    </th>
                  )
                }
                )}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {
            error ? (<tr><td colSpan={8}>Something went wrong; please reload the page...</td></tr>) : ( 
              !isLoaded ? (<tr><td colSpan={8}>Loading...</td></tr>) : (
              rows.map((row) => {
                prepareRow(row);
                const { key, ...restRowProps } = row.getRowProps();
                return (
                    <CarrierRow key={key} practiceId={practiceId} practiceName={practiceName} row={row} refreshCarrierList={refreshCarrierList}/>
                );
              })))
            }
          </tbody>
          <CarrierModal practiceId={practiceId} practiceName={practiceName} show={show} onHide={handleCancel} onSave={handleSave} />
        </Table>
    </Card>
  )
};


const CarrierManagement = () => {
  const [practiceId, setPracticeId] = useState(0);
  const [practiceName, setPracticeName] = useState(null);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    authenticatedFetch({
      path: "carrier/practices",
      successHandler: function(result) {
        if (result && result.length === 1)
        {
          // Skip the practice picker if there is only one practice
          setPracticeName(result[0].name);  // must do this first so practice name gets passed to carrier list
          setPracticeId(result[0].id);
        }

        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });

  }, []);

  const onPracticeChanged = (e) => {
    e.preventDefault();
    setPracticeId(parseInt(e.target.value));
    setPracticeName(e.target.options[e.target.selectedIndex].text)
  }

  const handleSelectDifferentPractice = (e) => {
    e.preventDefault();
    setPracticeId(0);
    setPracticeName(null)
  }

  const title = "Carrier Management" + (practiceName != null ? " | " + practiceName : "")

  return (
    <React.Fragment>
        <Helmet title={title} />
        <h1 className="h3 mb-3">{title}</h1>
        {practiceId > 0 && data.length > 1 ? <><Button variant="secondary" size="sm" onClick={(e) => {handleSelectDifferentPractice(e)}}>&lt; Select a different practice</Button><br /><br /></> : <></>}
        <Container fluid className="p-0">
          { practiceId > 0 ? <CarrierList practiceId={practiceId} practiceName={practiceName} /> : <SlimPracticePicker isLoaded={isLoaded} error={error} data={data} onPracticeChanged={onPracticeChanged} /> }    
        </Container>
    </React.Fragment>
  )
};

export default CarrierManagement;
